import React from 'react';

const HomeRepairRequirements = () => {
  return (
    <div>
      <section>
        <h4>Requisitos Técnicos</h4>
        <p>Para asegurar la correcta prestación del servicio será necesario que el equipo cumpla las siguientes especificaciones técnicas:</p>
        <ol>
          <li><strong>Conexión a internet mínima:</strong> 512 Kbps de subida/bajada.</li>
          <li>
            <strong>Requisitos mínimos para PC y MAC:</strong> Microsoft Windows (versiones soportadas por el fabricante), Apple MAC OS (versiones soportadas por el fabricante, con procesador Intel).
          </li>
        </ol>
      </section>

      <section>
        <h4>Aplicaciones y Dispositivos Soportados</h4>
        <ol>
          <li>
            <strong>Aplicaciones soportadas:</strong> el listado de aplicaciones y sistemas soportados corresponde a las propias del servicio Ayuda Tecnológica Online.
          </li>
          <li>
            <strong>Dispositivos soportados:</strong> equipos informáticos (PC) y sus periféricos (escáner, impresora, disco duro, router, modem).
          </li>
        </ol>
      </section>
    </div>
  );
};

export default HomeRepairRequirements;
